import React, { useEffect, useContext, useState } from "react";
import { AuthContext } from '../contexts/auth';
import { getInOutsEmployeeList, createEmployeeTimbratura, deleteEmployeeTimbratura, updateEmployeeTimbratura } from '../services/api_timbrature';
import { PencilSquareIcon, TrashIcon } from "@heroicons/react/24/outline";
import { MapPinIcon } from '@heroicons/react/24/solid';
import Swal from "sweetalert2";
import moment from "moment";
import LocationModal from "./location_modal";


const mesiInItaliano = [
  'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
  'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'
]


export default function TimbraturaCalendar({ employeeId }) {
  const { token, profile } = useContext(AuthContext);
  const [timbrature, setTimbrature] = useState({});
  const [loading, setLoading] = useState(true);
  const [day, setDay] = useState(new Date());
  const [showModal, setShowModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [timbraturaTimeCheckIn, setTimbraturaTimeChecKIn] = useState('');
  const [timbraturaTimeCheckOut, setTimbraturaTimeChecKOut] = useState('');
  const [selectedTimbratura, setSelectedTimbratura] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);


  const fetchData = async (selectedDay = day) => {
    const startOfMonth = moment(selectedDay).startOf('month').format('YYYY-MM-DD');
    const endOfMonth = moment(selectedDay).endOf('month').format('YYYY-MM-DD');
  
    setLoading(true);
    try {
      const response = await getInOutsEmployeeList(
        token,
        employeeId,
        startOfMonth,
        1,
        100,
        endOfMonth
      );
  
      const mappedTimbrature = response.results.reduce((acc, record) => {
        const date = moment(record.checkin).format('YYYY-MM-DD');
        if (!acc[date]) {
          acc[date] = [];
        }
        acc[date].push(record);
        return acc;
      }, {});
  
      setTimbrature(mappedTimbrature);
      setLoading(false);
    } catch (error) {
      console.error('Errore nel recupero delle timbrature:', error);
      setLoading(false);
    }
  };  

  useEffect(() => {
    fetchData();
  }, [day]);

  const nextMonth = () => {
    setDay(moment(day).add(1, 'month').toDate());
  };

  const prevMonth = () => {
    setDay(moment(day).subtract(1, 'month').toDate());
  };

  const setOggi = () => {
    setDay(new Date());
  };

  const openModal = (date) => {
    setSelectedDate(date);
    setShowModal(true);
  };
  
  const closeModal = () => {
    setShowModal(false);
    setTimbraturaTimeChecKIn('');
    setTimbraturaTimeChecKOut('');
  };
  
  const addTimbratura = async (data) => {
    try {
      const response = await createEmployeeTimbratura(token, employeeId, data);
      Swal.fire({
        title: 'Successo',
        text: 'Timbratura aggiunta con successo!',
        icon: 'success',
        showConfirmButton: false,
        timer: 1500,
      });
      fetchData(selectedDate);
    } catch (error) {
      console.error('Errore durante la creazione della timbratura:', error);
      let errorMessage = 'Non è stato possibile aggiungere la timbratura. Per favore riprova.';
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        const errorMessages = [];
  
        Object.keys(errorData).forEach((key) => {
          const messageArray = errorData[key];
          if (Array.isArray(messageArray)) {
            errorMessages.push(...messageArray);
          } else if (typeof messageArray === 'string') {
            errorMessages.push(messageArray);
          }
        });
  
        if (errorMessages.length > 0) {
          errorMessage = errorMessages.join(' ');
        }
      }
  
      Swal.fire({
        icon: 'error',
        title: 'Errore',
        text: errorMessage,
        confirmButtonText: 'OK',
      });
    }
  };
  
  const handleSaveTimbratura = async () => {
    if (!timbraturaTimeCheckIn) {
      Swal.fire({
        icon: 'error',
        title: 'Errore',
        text: 'L\'orario di ingresso è obbligatorio',
        confirmButtonText: 'OK',
      });
      return;
    }

    const [checkinHours, checkinMinutes] = timbraturaTimeCheckIn.split(':');
    const selectedCheckInTime = moment(selectedDate)
      .hours(checkinHours)
      .minutes(checkinMinutes)
      .seconds(0)
      .format('YYYY-MM-DDTHH:mm:ss');
  
    const [checkoutHours, checkoutMinutes] = timbraturaTimeCheckOut.split(':');
    const selectedCheckOutTime = timbraturaTimeCheckOut 
      ? moment(selectedDate)
          .hours(checkoutHours)
          .minutes(checkoutMinutes)
          .seconds(0)
          .format('YYYY-MM-DDTHH:mm:ss')
      : null;
 
    const data = {
      checkin: selectedCheckInTime,
      checkout: selectedCheckOutTime,
    };
  
    try {
      await addTimbratura(data);
      closeModal();
    } catch (error) {
      console.error(error);
    }
  };
  
  
  const handleEditTimbratura = (currentDay, timbratura) => {
    setSelectedTimbratura(timbratura);
    setShowEditModal(true);
  };

  const saveTimbratura = async (data) => {
    try {
      await updateEmployeeTimbratura(token, employeeId, selectedTimbratura.id, data);
      
      Swal.fire({
        title: 'Successo',
        text: 'Timbratura aggiornata con successo!',
        icon: 'success',
        showConfirmButton: false,
        timer: 1500,
      });
      
      setShowEditModal(false);
      fetchData();
    } catch (error) {
      console.error('Errore aggiornamento:', error);
  
      let errorMessage = 'Non è stato possibile aggiornare la timbratura. Per favore riprova.';

      if (!error.response) {
        errorMessage = 'Errore, riprova più tardi.';
      } else if (error.response && error.response.data) {
        const errorData = error.response.data;
        const errorMessages = [];

        Object.keys(errorData).forEach((key) => {
          const messageArray = errorData[key];
          if (Array.isArray(messageArray)) {
            errorMessages.push(...messageArray);
          } else if (typeof messageArray === 'string') {
            errorMessages.push(messageArray);
          }
        });

        if (errorMessages.length > 0) {
          errorMessage = errorMessages.join(' ');
        }
      }
  
      Swal.fire({
        icon: 'error',
        title: 'Errore',
        text: errorMessage,
        confirmButtonText: 'OK',
      });
    }
  };
  
  const handleDeleteTimbratura = (timbratura) => {   
    Swal.fire({
      title: 'Elimina Timbratura',
      text: 'Sei sicuro di voler eliminare questa timbratura?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Conferma',
      cancelButtonText: 'Annulla',
    }).then((result) => {
      if (result.isConfirmed) {
        const { employee, id } = timbratura;
        deleteEmployeeTimbratura(token, employee.id, id).then(() => {
          const updatedTimbrature = { ...timbrature };
          
          const date = moment(timbratura.checkin).format('YYYY-MM-DD');
          updatedTimbrature[date] = updatedTimbrature[date].filter(
            (t) => t.id !== timbratura.id
          );

          if (updatedTimbrature[date].length === 0) {
            delete updatedTimbrature[date];
          }
  
          setTimbrature(updatedTimbrature);
          
          Swal.fire({
            title: 'Successo',
            text: 'Timbratura eliminata con successo!',
            icon: 'success',
            showConfirmButton: false,
            timer: 1500,
          });
        }).catch((error) => {
          console.error('Errore durante l\'eliminazione della timbratura:', error);
          Swal.fire({
            icon: 'error',
            title: 'Errore',
            text: 'Non è stato possibile eliminare la timbratura. Per favore riprova.',
            confirmButtonText: 'OK',
          });
        });
      }
    });
  };
  
  
  
  return (
    <div>
      {loading && <p>Caricamento...</p>}
      <div className="px-4 sm:px-6 lg:px-8 mt-5">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
          <div className="relative flex items-center rounded-md bg-white md:items-stretch mt-3">
              <button onClick={prevMonth} type="button" className="flex h-9 w-12 items-center justify-center rounded-l-md border-y border-l border-gray-300 pr-1 text-gray-400 hover:text-gray-500 focus:relative md:w-9 md:pr-0 md:hover:bg-gray-50">
                <span className="sr-only">Mese Precedente</span>
                <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M12.79 5.23a.75.75 0 01-.02 1.06L8.832 10l3.938 3.71a.75.75 0 11-1.04 1.08l-4.5-4.25a.75.75 0 010-1.08l4.5-4.25a.75.75 0 011.06.02z" clipRule="evenodd"></path>
                </svg>
              </button>
              <button onClick={setOggi}
              type="button" className="hidden border-y border-gray-300 px-3.5 text-sm font-semibold text-gray-900 hover:bg-gray-50 focus:relative md:block">{mesiInItaliano[moment(day).format('M') - 1]} {moment(day).format('YYYY') }</button>
              <span className="relative -mx-px h-5 w-px bg-gray-300 md:hidden"></span>
              <button onClick={nextMonth} type="button" className="flex h-9 w-12 items-center justify-center rounded-r-md border-y border-r border-gray-300 pl-1 text-gray-400 hover:text-gray-500 focus:relative md:w-9 md:pl-0 md:hover:bg-gray-50">
                <span className="sr-only">Mese Successivo</span>
                <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z" clipRule="evenodd"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
        <Calendar 
          day={day} 
          timbrature={timbrature} 
          openModal={openModal} 
          handleEditTimbratura={handleEditTimbratura} 
          handleDeleteTimbratura={handleDeleteTimbratura}
          profile={profile} 
          />
        {showModal && (
          <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center" style={{ zIndex: '999'}}>
            <div className="bg-white p-8 rounded-lg shadow-lg">
              <h2 className="text-lg font-semibold mb-4">Aggiungi Timbratura</h2>
              <label className='text-sm text-gray-900 font-semibold'>{selectedDate && moment(selectedDate).format('DD/MM/YYYY')}</label>
              <div className="mb-4 mt-3">
                <label className="block mb-2 font-medium">Orario Ingresso *</label>
                <input
                  type="time"
                  className="border border-gray-300 rounded p-2 w-full "
                  value={timbraturaTimeCheckIn}
                  onChange={(e) => setTimbraturaTimeChecKIn(e.target.value)}
                />
              </div>
              <div>
                <label className="block mb-2 font-medium">Orario Uscita</label>
                  <input
                    type="time"
                    className="border border-gray-300 rounded p-2 w-full "
                    value={timbraturaTimeCheckOut}
                    onChange={(e) => setTimbraturaTimeChecKOut(e.target.value)}
                  />
              </div>
              <div className="flex justify-between space-x-4">
                <button
                  className="mt-3 rounded-md bg-white border border-gray-200 px-3 py-2 text-center text-sm font-semibold text-gray-800 shadow-sm hover:bg-gray-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-300 w-20"
                  onClick={closeModal}
                >
                  Annulla
                </button>
                <button
                  className="ml-4 mt-3 rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-300 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-300 w-20"
                  onClick={handleSaveTimbratura}
                >
                  Salva
                </button>
              </div>
            </div>
          </div>
        )}
        {showEditModal && (
          <EditTimbraturaModal
            timbratura={selectedTimbratura}
            onSave={saveTimbratura}
            onClose={() => setShowEditModal(false)}
          />
        )}
      </div>
    </div>
  );
}

const Calendar = ({ day, timbrature, openModal, handleEditTimbratura, handleDeleteTimbratura, profile }) => {
  const [isModalLocationOpen, setIsModalLocationOpen] = useState(false);
  const [modalLocations, setModalLocations] = useState([]);
  
  const hasPermission = (
    profile?.employee?.permissions.includes('hr.manage_inouts_all') || 
    profile?.employee?.permissions.includes('hr.manage_inouts_ou')
  );  

  const getDayOfWeek = (dateString) => {
    const days = ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'];
    return days[new Date(dateString).getDay()];
  };

  const getDaysOfMonth = (date) => {
    const startOfMonth = moment(date).startOf('month');
    const endOfMonth = moment(date).endOf('month');
    const days = [];
    let currentDay = startOfMonth;

    while (currentDay.isSameOrBefore(endOfMonth)) {
      days.push(currentDay.clone());
      currentDay = currentDay.add(1, 'day');
    }
    return days;
  };

  const daysInMonth = getDaysOfMonth(day);

  const handleOpenMap = (locations) => {
    if (locations.length === 0) {
      setModalLocations(null);
    } else {
      setModalLocations(locations);
    }
    setIsModalLocationOpen(true);
  };

  const handleCloseMap = () => {
    setIsModalLocationOpen(false);
    setModalLocations([]);
  };


  return (
    <div className="container mx-auto p-4">
      <div className="flex flex-col">
        {daysInMonth.map((currentDay) => (
          <div key={currentDay.format('YYYY-MM-DD')} className="flex items-center border-b border-gray-300 py-2">
            <div className="w-1/6 pe-4">
              <div>
                <div className="text-lg font-semibold">{currentDay.format('DD')}</div>
                <div className="text-sm text-gray-500">{getDayOfWeek(currentDay.format('YYYY-MM-DD'))}</div>
              </div>
            </div>
            <div className="w-5/6 flex flex-col">
              {timbrature[currentDay.format('YYYY-MM-DD')] ? (
                Object.values(timbrature)
                .flat()
                .filter(timbratura =>
                  moment(timbratura?.checkin).isSame(currentDay, 'day') ||
                  (timbratura?.checkout && moment(timbratura?.checkout).isSame(currentDay, 'day'))
                )
                  .sort((a, b) => {
                    const checkinA = moment(a.checkin);
                    const checkinB = moment(b.checkin);
                    return checkinA.isBefore(checkinB) ? -1 : 1;
                  })
                  .map((timbratura, index) => {
                    const locations = [];
                    if (timbratura.checkin_lat && timbratura.checkin_lng) {
                      locations.push({
                        latitude: timbratura.checkin_lat,
                        longitude: timbratura.checkin_lng,
                        accuracy: timbratura.checkin_accuracy || 50,
                        type: 'checkin',
                      });
                    }
                    if (timbratura.checkout_lat && timbratura.checkout_lng) {
                      locations.push({
                        latitude: timbratura.checkout_lat,
                        longitude: timbratura.checkout_lng,
                        accuracy: timbratura.checkout_accuracy || 50,
                        type: 'checkout',
                      });
                    }
                    return (
                    <div key={index} className="flex items-center justify-between bg-white border rounded-md p-2 mb-2">
                      <div className="text-sm">
                        <span className="font-semibold">Entrata</span> {timbratura.checkin ? moment(timbratura.checkin).format('HH:mm') : ''}
                        {timbratura.checkin && !moment(timbratura.checkin).isSame(currentDay, 'day') 
                          ? ` ${moment(timbratura.checkin).format('DD/MM/YYYY')}` 
                          : ''} <br />
                        <span className="font-semibold">Uscita</span> {timbratura.checkout ? moment(timbratura.checkout).format('HH:mm') : ''}
                        {timbratura.checkout && !moment(timbratura.checkout).isSame(currentDay, 'day') 
                          ? ` ${moment(timbratura.checkout).format('DD/MM/YYYY')}` 
                          : ''} <br />
                        <span className="font-semibold align-items me-1">Posizione Timbratura </span>
                        <MapPinIcon
                          className="inline-block h-5 w-5 mb-1 cursor-pointer text-indigo-600"
                          onClick={() => handleOpenMap(locations)}
                        />
                        <br />
                      </div>
                      {!(profile.customer_type === 'employee' && !hasPermission) && (
                        <div className="flex items-center space-x-2">
                          <PencilSquareIcon
                            className="w-6 h-6 cursor-pointer"
                            onClick={() => handleEditTimbratura(currentDay, timbratura)}
                          />
                          <TrashIcon
                            className="w-6 h-6 cursor-pointer"
                            onClick={() => handleDeleteTimbratura(timbratura)}
                          />
                        </div>
                      )}
                    </div>
                  )})
              ) : (
                <div className="text-sm text-gray-500">Nessuna registrazione</div>
              )}
              {!(profile.customer_type === 'employee' && !hasPermission) && (
                <div className="group w-full">
                  <button
                    onClick={() => openModal(currentDay)}
                    className="opacity-0 hover:opacity-100 group-hover:block rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-indigo-50 mt-2 w-full text-left"
                  >
                    Aggiungi registrazione
                  </button>
                </div> 
              )}
            </div>
          </div>
        ))}
        {isModalLocationOpen && (
          <LocationModal
            isOpen={isModalLocationOpen}
            onClose={handleCloseMap}
            locations={modalLocations}
          />
        )}
      </div>
    </div>
  );
};


const EditTimbraturaModal = ({ timbratura, onSave, onClose }) => {
  const [checkin, setCheckin] = useState(timbratura.checkin ? moment(timbratura.checkin).format('HH:mm') : '');
  const [checkout, setCheckout] = useState(timbratura.checkout ? moment(timbratura.checkout).format('HH:mm') : '');

  const handleSave = () => {
    const checkinMoment = moment(timbratura.checkin);

    const updatedCheckin = checkin
      ? checkinMoment
          .set({
            hour: moment(checkin, 'HH:mm').hour(),
            minute: moment(checkin, 'HH:mm').minute(),
          })
          .format('YYYY-MM-DDTHH:mm:ss')
      : null;

    const updatedCheckout = checkout
      ? checkinMoment
          .set({
            hour: moment(checkout, 'HH:mm').hour(),
            minute: moment(checkout, 'HH:mm').minute(),
          })
          .format('YYYY-MM-DDTHH:mm:ss')
      : null;

    const updatedData = {
      checkin: updatedCheckin,
      checkout: updatedCheckout,
    };

    onSave(updatedData);
    onClose();
  };


  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center" style={{ zIndex: '999' }}>
      <div className="bg-white p-8 rounded-lg shadow-lg">
        <h2 className="text-lg font-semibold mb-4">Modifica Timbratura</h2>
        <label className="text-sm text-gray-900 font-semibold">
          {timbratura && moment(timbratura.checkin).format('DD-MM-YYYY')}
        </label>
        <div className="mb-4 mt-3">
          <label className="block mb-2 font-medium">Orario Ingresso *</label>
          <input
            type="time"
            className="border border-gray-300 rounded p-2 w-full"
            value={checkin}
            onChange={(e) => setCheckin(e.target.value)}
          />
        </div>
        <div>
          <label className="block mb-2 font-medium">Orario Uscita</label>
          <input
            type="time"
            className="border border-gray-300 rounded p-2 w-full"
            value={checkout}
            onChange={(e) => setCheckout(e.target.value)}
          />
        </div>
        <div className="flex justify-between space-x-4">
          <button
            className="mt-3 rounded-md bg-white border border-gray-200 px-3 py-2 text-center text-sm font-semibold text-gray-800 shadow-sm hover:bg-gray-200"
            onClick={onClose}
          >
            Annulla
          </button>
          <button
            className="ml-4 mt-3 rounded-md bg-indigo-600 px-3 py-2 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-300"
            onClick={handleSave}
          >
            Salva
          </button>
        </div>
      </div>
    </div>
  );
};


